<div [formGroup]="formGroup">
  <p-autoComplete
    [inputId]="formCtrlId"
    formControlName="searchValue"
    field="label"
    #avansniSearch
    appendTo="body"
    emptyMessage="Račun nije pronađen"
    [suggestions]="vezaniRacunSuggestions"
    [placeholder]="ctrlPlaceholder"
    (completeMethod)="handleSearch($event)"
    (onSelect)="handleSelect($event)"
    (onClear)="handleClear()"
    [disabled]="shouldDisable"
  >
    <ng-template let-item pTemplate="item">
      <div class="p-d-flex p-jc-between" style="width: 200px">
        <div>{{ item.tipStr }}</div>
        <div class="p-text-bold">{{ item.label }}</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <kodit-error-info-required
    [formCtrl]="formGroup.controls.searchValue"
  ></kodit-error-info-required>
</div>
